import React from "react";

const ChipJobDetails = ({ title }) => {
  const label =
    typeof title === "string"
      ? title
      : title?.value || title?.name || title?.skill || "";

  return (
    <div className="chipJobDetailsCard">
      <div className="chipJobDetailsCard-m1">{label}</div>
    </div>
  );
};

export default ChipJobDetails;
